import { Controller } from "@hotwired/stimulus"

// back-link — "voltar" inteligente: se o usuário chegou a esta página navegando
// de DENTRO do app, volta no histórico do navegador (history.back() — restaura
// scroll e estado da página anterior nativamente). Senão (abriu a URL direto,
// veio de fora, ou recarregou), segue o href de FALLBACK — o destino canônico.
//
// POR QUE NÃO document.referrer: com Turbo Drive a navegação é fetch +
// history.pushState, que NÃO atualiza document.referrer (fica vazio/da carga
// inicial). Então rastreamos a navegação interna nós mesmos: a cada visita Turbo
// marcamos um flag em sessionStorage. Se o flag existe quando o "voltar" é clicado,
// houve navegação interna anterior nesta aba → history.back() é seguro.
//
// CSP-safe (sem handler inline). Uso: no <a href="<fallback>">
//   data-controller="back-link"
//   data-action="back-link#go"
//   data-back-link-fallback-value="<mesmo href>"
const NAV_FLAG = "back-link:internal-nav"

// Registra UMA vez por documento: marca o flag a cada visita interna do Turbo. A
// primeira visita da aba (turbo:load inicial) não conta como "navegação interna
// anterior" — só as subsequentes (turbo:visit dispara ao seguir um link interno).
if (typeof window !== "undefined" && !window.__backLinkNavTracked) {
  window.__backLinkNavTracked = true
  document.addEventListener("turbo:visit", () => {
    sessionStorage.setItem(NAV_FLAG, "1")
  })
}

export default class extends Controller {
  static values = { fallback: String }

  go(event) {
    if (this._cameFromInternalNav()) {
      event.preventDefault()
      history.back()
    }
    // Senão: não previne o default → o link segue o href de fallback (Turbo).
  }

  // Houve ao menos uma navegação interna (Turbo visit) antes de chegar aqui?
  _cameFromInternalNav() {
    return history.length > 1 && sessionStorage.getItem(NAV_FLAG) === "1"
  }
}
